<template>
    <div class="weichat-bind">
        <loading v-if="loading" msg="正在验证用户..."></loading>
        <div v-else>
            <div v-if="error">
                发生错误，请重新进入
            </div>
            <div v-else>
<!--                <img src="../../assets/img/sas.jpg" class="bgImg" style="width: 100%;height: 100%;">-->
                <div>
                    <h3 class="h3">绑定微信用户</h3>
                    <el-form ref="form" class="bindWXform">
                        <el-form-item>
                            <span class="form-laber" style="margin-right:5px;"><i
                                    class="loginicon iconfont icon-zhanghao" style="color:#48B5FA;"></i>用户名：</span>
                            <el-input v-model.trim="form.name"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <span class="form-laber"><i class="loginicon iconfont icon-mima" style="color:#FBC419;"></i>密码：</span>
                            <el-input v-model.trim="form.pwd" show-password></el-input>
                        </el-form-item>
                        <el-button round type="primary" @click="onBind" :loading="saving" class="login_btn">立即绑定
                        </el-button>
                    </el-form>
<!--                    <div style="margin-top: 15px">-->
<!--                        <div class="text-12" style="text-align: center;color: #A9A9AB;">2020@石家庄云松信息科技有限公司<br>保留所有权利-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {ssoApi} from "@/api/organization";
    import {Dialog} from 'vant';
    import Loading from "../../components/Loading";
    import {mapMutations} from "vuex";
    export default {
        name: "Login",
        components:{
            Loading
        },
        data() {
            return {
                loading: true,
                saving: false,
                error: false,
                form: {
                    replace: false,
                    name: '',
                    pwd: '',
                    openId: '',
                    unionId: '',
                },
            }
        },
        created() {
            const code = this.$route.query.code;
            ssoApi.mpLogin(code).then(r => {
                this.loading = false;
                if (r.data.result === 0) {
                    this.updateAndGo(r.data.data);
                } else if (r.data.result === 1) {
                    this.form.openId = r.data.data.openId;
                    this.form.unionId = r.data.data.unionId;
                } else {
                    // this.$router.replace('/mp/login');
                    this.error = true;
                }
            }).catch(() => {
                this.loading = false;
                this.error = true;
            });
        },
        methods:{
            ...mapMutations(["changeLogin"]),
            updateAndGo(rd) {
                this.changeLogin(rd);
                this.$router.replace('/mp/index');
            },
            onBind(replace){
                this.saving = true;
                if (replace === undefined) {
                    replace = false;
                }
                this.form.replace = replace;
                ssoApi.mpBind(this.form).then(r => {
                    this.saving = false;
                    if (r.data.result === 0) {
                        this.updateAndGo(r.data.data);
                    } else if (r.data.result < -10) {
                        Dialog.confirm({
                            title: '提示',
                            message: '账户已绑定其他微信，是否替换？',
                            confirmButtonText: '替换',
                            cancelButtonText: '取消',
                        }).then(() => {
                            this.onBind(true);
                        });
                    }
                }).catch(() => {
                    this.saving = false;
                });
            },
        }
    }
</script>

<style lang="scss">
    .weichat-bind {
        .text-12 {
            font-size: 12px;
        }

        .bgImg {
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: -1;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }

        .h3 {
            text-align: center;
            margin: 50px auto;
            font-size: 1.36em;
        }

        .bindWXform {
            width: 88%;
            margin-left: 6%;

            .el-form-item {
                border-bottom: 1px solid #e4e4e4;
                margin: 15px 10px 10px;

                .el-form-item__content {
                    line-height: 46px;

                    .form-laber {
                        font-size: 16px;
                        margin-right: 20px;
                        color: #606266;
                    }

                    .el-input {
                        display: inline-block;
                        width: calc(100% - 110px);

                        .el-input__inner {
                            border: none;
                            padding-left: 0;
                            font-size: 16px;
                            color: #333;
                        }

                    }

                    .el-input__suffix-inner {
                        i {
                            font-size: 20px
                        }
                    }

                    .loginicon {
                        font-size: 20px;
                        margin-right: 10px;
                    }

                    .qxs-icon {
                        height: 52px;
                        width: 90%;
                        padding-left: 10%;
                        border: 0;
                        border-bottom: solid 1px lavender;

                        &:focus {
                            outline: none;
                        }
                    }
                }

                &:focus, &:hover {
                    border-bottom: 1px solid #67C13B !important;
                    outline: 0;
                }
            }

            .login_btn {
                width: 90%;
                font-size: 16px;
                margin: 40px 0 0 5%;
            }
        }

        .outer_label {
            position: relative;
            left: 0;
            top: 0;
            width: 100%;
            height: 80px;
            margin-top: 50px;
            text-align: center;

            .inner_label {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                margin: auto;
                height: 88px;
            }

            .login_logo {
                width: 80px;
                height: 80px;
            }
        }
    }
    .el-message {
        top: 0 !important;
        padding: 10px 15px;
    }
</style>